/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedContactRouteImport } from './routes/_authenticated/contact'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedWelcomeRouteImport } from './routes/_authenticated/welcome'
import { Route as AuthSigninRouteImport } from './routes/auth.signin'
import { Route as AuthenticatedAdminWaitlistRouteImport } from './routes/_authenticated/admin/waitlist'
import { Route as AuthenticatedStoriesIndexRouteImport } from './routes/_authenticated/stories.index'
import { Route as AuthenticatedStoriesIdRouteImport } from './routes/_authenticated/stories.$id'
import { Route as AuthenticatedAdminStoriesIdRouteImport } from './routes/_authenticated/admin/stories.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const WaitlistRoute = WaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedContactRoute = AuthenticatedContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWelcomeRoute = AuthenticatedWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminWaitlistRoute =
  AuthenticatedAdminWaitlistRouteImport.update({
    id: '/admin/waitlist',
    path: '/admin/waitlist',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStoriesIndexRoute =
  AuthenticatedStoriesIndexRouteImport.update({
    id: '/stories/',
    path: '/stories/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStoriesIdRoute = AuthenticatedStoriesIdRouteImport.update({
  id: '/stories/$id',
  path: '/stories/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminStoriesIdRoute =
  AuthenticatedAdminStoriesIdRouteImport.update({
    id: '/admin/stories/$id',
    path: '/admin/stories/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/waitlist': typeof WaitlistRoute
  '/account': typeof AuthenticatedAccountRoute
  '/contact': typeof AuthenticatedContactRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/welcome': typeof AuthenticatedWelcomeRoute
  '/auth/signin': typeof AuthSigninRoute
  '/admin/waitlist': typeof AuthenticatedAdminWaitlistRoute
  '/stories/$id': typeof AuthenticatedStoriesIdRoute
  '/stories/': typeof AuthenticatedStoriesIndexRoute
  '/admin/stories/$id': typeof AuthenticatedAdminStoriesIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/waitlist': typeof WaitlistRoute
  '/account': typeof AuthenticatedAccountRoute
  '/contact': typeof AuthenticatedContactRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/welcome': typeof AuthenticatedWelcomeRoute
  '/auth/signin': typeof AuthSigninRoute
  '/admin/waitlist': typeof AuthenticatedAdminWaitlistRoute
  '/stories/$id': typeof AuthenticatedStoriesIdRoute
  '/stories': typeof AuthenticatedStoriesIndexRoute
  '/admin/stories/$id': typeof AuthenticatedAdminStoriesIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/waitlist': typeof WaitlistRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/contact': typeof AuthenticatedContactRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/welcome': typeof AuthenticatedWelcomeRoute
  '/auth/signin': typeof AuthSigninRoute
  '/_authenticated/admin/waitlist': typeof AuthenticatedAdminWaitlistRoute
  '/_authenticated/stories/$id': typeof AuthenticatedStoriesIdRoute
  '/_authenticated/stories/': typeof AuthenticatedStoriesIndexRoute
  '/_authenticated/admin/stories/$id': typeof AuthenticatedAdminStoriesIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/waitlist'
    | '/account'
    | '/contact'
    | '/settings'
    | '/welcome'
    | '/auth/signin'
    | '/admin/waitlist'
    | '/stories/$id'
    | '/stories/'
    | '/admin/stories/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/waitlist'
    | '/account'
    | '/contact'
    | '/settings'
    | '/welcome'
    | '/auth/signin'
    | '/admin/waitlist'
    | '/stories/$id'
    | '/stories'
    | '/admin/stories/$id'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/waitlist'
    | '/_authenticated/account'
    | '/_authenticated/contact'
    | '/_authenticated/settings'
    | '/_authenticated/welcome'
    | '/auth/signin'
    | '/_authenticated/admin/waitlist'
    | '/_authenticated/stories/$id'
    | '/_authenticated/stories/'
    | '/_authenticated/admin/stories/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  WaitlistRoute: typeof WaitlistRoute
  AuthSigninRoute: typeof AuthSigninRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contact': {
      id: '/_authenticated/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof AuthenticatedContactRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/welcome': {
      id: '/_authenticated/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthenticatedWelcomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin/waitlist': {
      id: '/_authenticated/admin/waitlist'
      path: '/admin/waitlist'
      fullPath: '/admin/waitlist'
      preLoaderRoute: typeof AuthenticatedAdminWaitlistRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stories/': {
      id: '/_authenticated/stories/'
      path: '/stories'
      fullPath: '/stories/'
      preLoaderRoute: typeof AuthenticatedStoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stories/$id': {
      id: '/_authenticated/stories/$id'
      path: '/stories/$id'
      fullPath: '/stories/$id'
      preLoaderRoute: typeof AuthenticatedStoriesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/stories/$id': {
      id: '/_authenticated/admin/stories/$id'
      path: '/admin/stories/$id'
      fullPath: '/admin/stories/$id'
      preLoaderRoute: typeof AuthenticatedAdminStoriesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedContactRoute: typeof AuthenticatedContactRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedWelcomeRoute: typeof AuthenticatedWelcomeRoute
  AuthenticatedAdminWaitlistRoute: typeof AuthenticatedAdminWaitlistRoute
  AuthenticatedStoriesIdRoute: typeof AuthenticatedStoriesIdRoute
  AuthenticatedStoriesIndexRoute: typeof AuthenticatedStoriesIndexRoute
  AuthenticatedAdminStoriesIdRoute: typeof AuthenticatedAdminStoriesIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedContactRoute: AuthenticatedContactRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedWelcomeRoute: AuthenticatedWelcomeRoute,
  AuthenticatedAdminWaitlistRoute: AuthenticatedAdminWaitlistRoute,
  AuthenticatedStoriesIdRoute: AuthenticatedStoriesIdRoute,
  AuthenticatedStoriesIndexRoute: AuthenticatedStoriesIndexRoute,
  AuthenticatedAdminStoriesIdRoute: AuthenticatedAdminStoriesIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  WaitlistRoute: WaitlistRoute,
  AuthSigninRoute: AuthSigninRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
